import type { CrmChildRow } from '../ChildList/CrmChildListStore'

/**
 * Підписи полів документа CRM (`SPEC-008` §4.4) — тексти легасі
 * (`ClientDocumentFormTemplate.jsx:5-11`, `uk.json:52,80,92-94,404`).
 * «З печаткою та підписом» тут немає: це параметр шухляди генерації
 * (`SPEC-012` N-17).
 */
export const CRM_DOCUMENT_FIELD_LABELS = {
    documentType: 'Тип документа',
    title: 'Назва',
    number: 'Номер документу',
    date: 'Дата документа',
    wordFile: 'Word файл',
    pdfFile: 'Pdf файл',
    createdAt: 'Дата створення',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const

/** Файлові поля документа: їх вантажать окремими запитами, а не збереженням форми. */
export const CRM_DOCUMENT_FILE_FIELDS = ['wordFile', 'pdfFile'] as const

export type CrmDocumentFileField = (typeof CRM_DOCUMENT_FILE_FIELDS)[number]

/** Документ так, як його віддає колекція (`crm_document:collection:read`). */
export interface CrmDocumentRow extends CrmChildRow {
    /** «<номер> <дд.мм.рррр>» — рахує бек при кожному збереженні (КЛ-28) */
    title?: string | null
    number?: string | null
    date?: string | null
    documentType?: { '@id'?: string; title?: string | null } | null
    wordFile?: unknown
    pdfFile?: unknown
}
